import script from "./PackageSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageSection.vue?vue&type=script&setup=true&lang=js"

import "./PackageSection.vue?vue&type=style&index=0&id=5b8d131f&lang=css"

const __exports__ = script;

export default __exports__